import React, { useState } from 'react';
import { FiMonitor, FiCreditCard, FiGlobe, FiArrowUpRight } from 'react-icons/fi';
import './Loans.css';
import ApplicationForm from './ApplicationForm';
import { triggerApplyModal } from '../App';

const Loans = () => {
  const [showApplicationForm, setShowApplicationForm] = useState(false);

  return (
    <div className="loans-page" style={{ paddingTop: '6rem', minHeight: '85vh' }}>
      <div className="fintech-container">
        <div className="loans-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <span className="section-eyebrow">FINTECH SOFTWARE SOLUTIONS</span>
          <h1 className="gradient-text">Custom Fintech & Banking Software Engineering</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.15rem', maxWidth: '750px', margin: '0.75rem auto 0', lineHeight: '1.7' }}>
            Kubersetu Infotech Private Limited is a specialized technology company that builds custom fintech software, automated loan origination platforms, e-KYC integration suites, and NBFC portals for financial enterprises and startups.
          </p>
        </div>

        <div className="bento-box" style={{ maxWidth: '850px', margin: '0 auto 3rem', padding: '3rem 2rem', textAlign: 'center' }}>
          <span style={{ fontSize: '3rem', display: 'flex', gap: '0.5rem', justifyContent: 'center', marginBottom: '1rem' }}><FiMonitor /><FiCreditCard /></span>
          <h2 style={{ fontSize: '1.8rem', color: '#ffffff', marginBottom: '1rem' }}>
            Looking for Custom Technology Solutions?
          </h2>
          <p style={{ color: 'var(--text-muted)', lineHeight: '1.7', marginBottom: '2rem', fontSize: '1.05rem' }}>
            We engineer high-performance web applications, mobile apps (iOS & Android), payment integrations, and cloud SaaS platforms tailored to your business needs.
          </p>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="/services" 
              className="btn btn-primary"
              style={{ textDecoration: 'none', padding: '0.85rem 2rem' }}
            >
              Explore Tech Services <FiGlobe />
            </a>
            <button 
              className="btn btn-secondary"
              onClick={() => triggerApplyModal('Fintech & Payment Software Solutions')}
              style={{ padding: '0.85rem 2rem' }}
            >
              Request Tech Quote <FiArrowUpRight />
            </button>
          </div>
        </div>
      </div>

      {showApplicationForm && (
        <ApplicationForm onClose={() => setShowApplicationForm(false)} />
      )}
    </div>
  );
};

export default Loans;
